import './App.css';
import './index.css';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import StatementSummary from './Scenes/StatementSummary';
import Help from './Scenes/Help';
import ManageAccount from './Scenes/ManageAccount';
import QuickPay from './Scenes/QuickPay';
import BillHistory from './Scenes/BillHistory';
import ErrorPage from './Scenes/ErrorPage';

import React, { useState, useEffect } from "react";
import QuickPaySubmitted from './Scenes/QuickPaySubmitted';
import * as helpers from './helpers';
import { useMsal } from '@azure/msal-react';
import StatementSummaryComplete from './Scenes/StatementSummaryComplete';
import { b2cPolicies } from './authConfig';
import { paymentClientPromise } from "./payments";
import {
  isLocalAuthDisabled,
  localBeehiveOnlineContactId,
  localStripeCustomerId,
} from "./localRuntime";

function App(props) {
  const authDisabled = props.authDisabled || isLocalAuthDisabled;
  const [customerId, setCustomerId] = useState('');
  const [bettyUser, setBettyUser] = useState('');
  const [stripeUser, setStripeUser] = useState('');
  const [init, setInit] = useState(false);

  const [activeAccount, setActiveAccount] = useState('');

  const { instance, accounts, inProgress } = useMsal();

  if (!init && props.loggedIn) {
    if (!window.getKey) {
      window.getKey = (callback) => {
        if (authDisabled) {
          callback("");
          return;
        }

        if (!accounts || !accounts[0]) {
          callback("");
          return;
        }

        let curAct = instance.getAccountByHomeId(accounts[0].homeAccountId);
        let request = {
          scopes: [],
          account: curAct
        }

        instance.acquireTokenSilent(request).then((result) => {
          callback(result.idToken);
        }).catch((err) => {
          console.log("get key silent failed: ");
          instance.logout({ account: curAct });
          instance.loginRedirect({ authority: b2cPolicies.authorities.signUpSignIn.authority });
        })
      }
    }
  }

  let resolveCustomerId = (overrideCustomerId) => {
    if (overrideCustomerId) {
      return overrideCustomerId;
    }

    if (customerId) {
      return customerId;
    }

    if (authDisabled) {
      return localStripeCustomerId;
    }

    if (accounts && accounts[0] && accounts[0].idTokenClaims) {
      return accounts[0].idTokenClaims.extension_CustomerId;
    }

    return undefined;
  }

  let getUserData = (overrideCustomerId) => {
    let thisCustomerId = resolveCustomerId(overrideCustomerId);
    if (!thisCustomerId) {
      return;
    }

    helpers.apiAuth('GetAccount', {}, (result) => {
      setBettyUser({ user: result });
      setActiveAccount(result.Accounts[0]);
    });
    helpers.apiAuth('GetStripeCustomerData', { customerId: thisCustomerId }, (result) => {
      setStripeUser({ customer: result.customer, paymentMethods: result.paymentMethods, bankAccountsPM: result.bankAccountsPM });
    });
  }
  let initialPage = props.loggedIn ? 'statement-summary' : 'quickpay';
  if (window.location.pathname === '/quickpaysubmitted') {
    initialPage = 'quickpaysubmitted';
  }
  if (window.location.pathname === '/quickpaysubmitted?failed') {
    initialPage = 'quickpaysubmitted?failed';
  }

  //URL Parameters
  let params = new URLSearchParams(window.location.search);
  let amount = params.get('amount');
  let failed = params.get('failed');
  const dbCustomerId = authDisabled
    ? localBeehiveOnlineContactId || customerId
    : customerId;

  useEffect(() => {
    if (!init && window.getKey) {
      setInit(true);

      if (authDisabled) {
        if (!props.loggedIn || !localStripeCustomerId) {
          return;
        }

        setCustomerId(localStripeCustomerId);
        getUserData(localStripeCustomerId);
        return;
      }

      if (!accounts || !accounts[0] || !accounts[0].idTokenClaims) {
        return;
      }

      const claimCustomerId = accounts[0].idTokenClaims.extension_CustomerId;
      setCustomerId(claimCustomerId);
      getUserData(claimCustomerId);
    }
  })

  return (
    <div className="App">
      <Router>
        <Redirect exact from="/" to={initialPage} />
        <Switch>
          <Route path="/quickpaysubmitted" component={() => <QuickPaySubmitted authentication={props.authentication} amount={amount} failed={failed} />} />
          <Route path="/statement-summary" component={() => <StatementSummary authentication={props.authentication} stripePromise={paymentClientPromise} bettyUser={bettyUser} stripeUser={stripeUser} getUserData={getUserData} activeAccount={activeAccount} setActiveAccount={setActiveAccount} customerId={customerId}/*setBettyUser={setBettyUser} setStripeUser={setStripeUser}*/ />} />
          <Route path="/account" component={() => <ManageAccount authentication={props.authentication} stripePromise={paymentClientPromise} bettyUser={bettyUser} stripeUser={stripeUser} getUserData={getUserData} activeAccount={activeAccount} setActiveAccount={setActiveAccount} setBettyUser={setBettyUser} customerId={customerId} dbCustomerId={dbCustomerId} setStripeUser={setStripeUser} />} />
          <Route path="/help" component={() => <Help authentication={props.authentication} bettyUser={bettyUser} activeAccount={activeAccount} setActiveAccount={setActiveAccount} />} />
          <Route path="/statement-summary-complete" component={() => <StatementSummaryComplete activeAccount={activeAccount} setActiveAccount={setActiveAccount} bettyUser={bettyUser} amount={amount} getUserData={getUserData} />} />
          <Route path="/quickpay" component={() => <QuickPay authentication={props.authentication} stripePromise={paymentClientPromise} />} />
          <Route path="/bill-history" component={() => <BillHistory authentication={props.authentication} bettyUser={bettyUser} activeAccount={activeAccount} setActiveAccount={setActiveAccount} />} />
          <Route path="/error" component={() => <ErrorPage />} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
